// Utility functions for form downloads and external links

/**
 * Opens the Airtable form in a new tab
 */
export const openAirtableForm = () => {
  const formUrl = 'https://airtable.com/appACmOHlc4Sd1bdW/pagb3EGhMsbcdjTaK/form';
  window.open(formUrl, '_blank', 'noopener,noreferrer');
};

/**
 * Triggers download of the PDF form
 */
export const downloadPDFForm = () => {
  const pdfUrl = '/forms/reckoning-project-questionnaire.pdf';
  const link = document.createElement('a');
  link.href = pdfUrl;
  link.download = 'Reckoning-Project-Questionnaire.pdf';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * Email contact utility
 */
export const sendEmail = (subject = '', body = '') => {
  const email = 'info@thereckoningproject.org';
  const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = mailtoUrl;
};

/**
 * Formats contact information for display
 */
export const getContactInfo = () => {
  return {
    email: 'info@thereckoningproject.org',
    mailingAddress: {
      organization: 'The Reckoning Project',
      poBox: '#765',
      streetAddress: '1200 NW Pennsylvania Ave',
      cityStateZip: 'Washington, DC 20044'
    }
  };
};
